import { useState, useEffect } from 'react';

type Theme = 'light' | 'dark';

const STORAGE_KEY = 'consultoraHub_theme';

export function useTheme() {
  // Detectar preferencia del sistema
  const getSystemPreference = (): Theme => {
    if (typeof window !== 'undefined' && window.matchMedia) {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    return 'light';
  };

  // Inicializar tema desde localStorage o sistema
  const [theme, setThemeState] = useState<Theme>(() => {
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem(STORAGE_KEY) as Theme | null;
      return stored || getSystemPreference();
    }
    return 'light';
  });

  // Aplicar tema al elemento raíz
  useEffect(() => {
    const root = window.document.documentElement;

    // Remover ambas clases
    root.classList.remove('light', 'dark');

    // Agregar la clase correspondiente
    root.classList.add(theme);

    // Guardar en localStorage
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  // Función para cambiar tema
  const setTheme = (newTheme: Theme) => {
    setThemeState(newTheme);
  };

  // Función para toggle
  const toggleTheme = () => {
    setThemeState(prev => prev === 'light' ? 'dark' : 'light');
  };

  return {
    theme,
    setTheme,
    toggleTheme,
    isDark: theme === 'dark',
  };
}
